import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "list-container" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("div", { class: "terms-container" }, [
      _createElementVNode("div", { class: "agreement-content" }, _toDisplayString(`Message List`)),
      _createElementVNode("div", { class: "agreement-title" }, _toDisplayString('Title'))
    ], -1)
  ])))
}